export default __webpack_public_path__ + "static/media/gravityRush.07381ad0.jpg";